export default __webpack_public_path__ + "static/media/error.71aa2d7d.svg";